// extracted by mini-css-extract-plugin
export var addressFields = "_k2-0";
export var animationContainer = "_k2-1";
export var footer = "_k2-2";
export var lineItems = "_k2-3";
export var modalContent = "_k2-4";
export var orderName = "_k2-5";
export var strong = "_k2-6";
export var warning = "_k2-7";